import React from 'react';
import { FormattedMessage } from 'react-intl';

import { importComponent } from '@xingternal/hops';

import { useLoginStates } from '@/hooks';

import { useSearchAlertModal } from '../../contexts';
import { SearchAlertDialog } from './search-alert-dialog';
import { SearchAlertModalWrapper } from './search-alert-modal-wrapper';
import { useAlertModal } from './use-alert-modal';

import * as S from './search-alert-modal.styles';

const SearchAlertModalLoggedInContent = importComponent(
  () => import('./search-alert-modal-li-content'),
  ({ SearchAlertModalLoggedInContent }) => SearchAlertModalLoggedInContent
);

const SearchAlertModalLoggedOutContent = importComponent(
  () => import('./search-alert-modal-lo-content'),
  ({ SearchAlertModalLoggedOutContent }) => SearchAlertModalLoggedOutContent
);

export const SearchAlertModal: React.VFC = () => {
  const { email, isInvalidEmail, onEmailChange, onValidate } = useAlertModal();
  const { isLoggedIn } = useLoginStates();
  const { modalType, toggleModal, stringifiedQuery } = useSearchAlertModal();

  const handleCloseClick = (): void => {
    toggleModal();
  };

  const getAlertModalContent = (): JSX.Element =>
    isLoggedIn ? (
      <SearchAlertModalLoggedInContent modalType={modalType} stringifiedQuery={stringifiedQuery} />
    ) : (
      <SearchAlertModalLoggedOutContent
        modalType={modalType}
        stringifiedQuery={stringifiedQuery}
        email={email}
        handleEmailOnChange={onEmailChange}
        isInvalidEmail={isInvalidEmail}
      />
    );

  return (
    <>
      <SearchAlertModalWrapper
        isShown={modalType === 'DEFAULT' || modalType === 'REPEATED_SEARCH'}
        handleCloseClick={handleCloseClick}
      >
        <S.Image size="large" />
        {getAlertModalContent()}
        <S.AlertButton
          variant="primary"
          {...(!isLoggedIn ? { previousValidationOnClick: onValidate, email } : {})}
          inDialog
          showIcon={isLoggedIn}
        />
        <S.TextButton onClick={handleCloseClick}>
          <FormattedMessage id="JOBS_MULTIPLE_TIMES_SEARCH_ALERT_CANCEL" />
        </S.TextButton>
      </SearchAlertModalWrapper>
      <SearchAlertDialog onClose={handleCloseClick} show={modalType === 'DIALOG'} />
    </>
  );
};
